import * as React from 'react';
import { t } from '@moovly/i18n';
import DashboardBarChartCard from '../components/DashboardBarChartCard';
import DashboardGraphList from '../components/DashboardGraphList';
import useGroupGraphData from '../hooks/useGroupGraphData';
import AnalyticsFilter from '../components/AnalyticsFilter';

const AnalyticsContainer = () => {
  const [months, selectMonths] = React.useState<number>(3);
  const { projectData, renderData, userData, subscriptionData } = useGroupGraphData(months);

  return (
    <>
      <div className="mt-4 mb-5">
        <AnalyticsFilter months={months} onSelectMonths={selectMonths} />
      </div>
      <DashboardGraphList>
        <DashboardBarChartCard title={t('home.statistics.users.users')} data={userData} />
        <DashboardBarChartCard title={t('home.statistics.projects.title')} data={projectData} />
        <DashboardBarChartCard title={t('home.statistics.projects.renders')} data={renderData} />
        <DashboardBarChartCard title={t('home.statistics.seats.seats')} data={subscriptionData} />
      </DashboardGraphList>
    </>
  );
};

export default AnalyticsContainer;
